import { PrintersModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<PrintersModel>('/ipad/printers');
export default api;
